import Discount from "../Discount";
import Printer from "../Printer.vue";
import Calc from "../Calc.vue";
import CustomLoadingComponent from "@/views/pages/customLoadingComponent";
import QrReader from "../QrReader.vue";
import { uuid } from "vue-uuid";
import { completePayment, addDiscountLog } from "@/api/SelfService";
import SelectPaymentType from "../SelectPaymentType.vue";
import { FindAvailableCampaigns } from "@/api/Campaign.js";
import { getPosSettings } from "@/api/AppSettings";
import { setBranchCart, getOrderEntries, getCartsByTableId, getCarts, reserveTable, triggerKitchenPrintBySID } from "@/api/Cart";
import { getAllKitchen } from "@/api/Kitchen";

export default {
  props: {
    currentTime: {
      type: String,
      required: true,
    },
    currentDate: {
      type: String,
      required: true,
    },
    isTableMode: {
      type: Boolean,
      required: true,
    },
    isKiosk: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CustomLoadingComponent,
    Calc,
    SelectPaymentType,
    Printer,
    Discount,
    QrReader,
  },
  data() {
    return {
      cloneCurrentCart: [],
      selectedGift: null,
      isPosEnabled: false,
      isPrintOrders: true,
      isTransaction: false,
      showPaymentHistory: false,
      isCommitable: false,
      selectedPaymentGroup: [],
      isActive: false,
      orderPayments: [],
      paymentGroups: [],
      separatePaymentPrice: 0,
      paymentDiscount: {},
      discounts: [],
      ids: [],
      isPieced: false,
      posType: 0,
      orderBillNo: 0,
      // Merge modal data
      isMergeModalOpen: false,
      newMergePrice: "",
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
      selectedGroupsForMerge: [],
      totalPayedPriceForMerge: 0,
      localBranchTableUId: null, // [v26] UUID Anchor
      localBranchId: null,       // [v26] Branch Anchor
      tableId: null,            // [v26] Table ID Anchor
      kitchens: [],
    };
  },
  watch: {
    selectedPaymentGroup(newVal, oldVal) {
      if (newVal.length > 0) {
        let lastItem = newVal[newVal.length - 1];
        if (lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = oldVal;
        }
      }
    },
    isActive: function (val) {
      if (val) {
        this.initValues();
        this.initGifts();
        this.loadKitchens();
        
        const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
          const creditId = process.env.VUE_APP_CREDIT_PAYMENT_ID ? parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID) : 2;
          const creditCardMethod = sessionPaymentMethods.find(m => m.id == creditId);
          if (creditCardMethod) {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
          } else {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
          }
        }
      } else {
        this.selectedPaymentGroup = [];
        this.paymentGroups = [];
        this.orderPayments = [];
      }
    },
    totalPrice: function (val) {
      const roundedVal = Math.round(val * 100) / 100;
      if (roundedVal <= 0) {
        this.isCommitable = true;
      } else {
        this.isCommitable = false;
      }
    },
    selectedPaymentMethod(val) {
      if (val.id == 4) this.isActiveDiscount = true;
    },
  },
  computed: {
    orderBillEntries() {
      try {
        let currentCart = this.$store.getters["selfservice/getCurrentCart"];
        
        // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
        if (!currentCart && this.localBranchTableUId) {
           console.warn("orderBillEntries (OrderList Recovery): currentCart is NULL, attempting recovery by UUID:", this.localBranchTableUId);
           const allCarts = this.$store.getters["selfservice/getCarts"];
           currentCart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
           if (currentCart) console.log("orderBillEntries (OrderList fallback): Cart found.");
        }

        if (!currentCart || !currentCart.cartEntries) return [];
        
        let result = [];
        currentCart.cartEntries.forEach((entry) => {
          const entryCopy = {
            id: entry.id,
            productName: entry.productName,
            quantity: entry.quantity,
            productQuantity: entry.productQuantity,
            price: entry.price,
            originPrice: entry.originPrice || entry.price,
            variantItems: (entry.recipe && entry.recipe.steps) ? entry.recipe.steps.filter((x) => x.selected == true && x.isDefault == false) : [],
            recipe: entry.recipe,
            extras: entry.extras,
            note: entry.note,
            userName: entry.userName,
            time: entry.time,
            createdDate: entry.createdDate,
            isTime: entry.isTime,
            totalHour: entry.totalHour
          };
          result.push(entryCopy);
        });
        return result;
      } catch (error) {
        console.error("orderBillEntries error:", error);
        return [];
      }
    },
    isMobile() {
      return window.innerWidth <= 768; // Adjust the width as needed for mobile
    },
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      },
    },
    totalDiscountPrice() {
      let paymentDiscounts = this.orderPayments.reduce(function (total, num) {
        if (num.paymentMethod.id == 4 && num.paymentMethod.name == "İndirim")
          return total + (num.price || 0);
        else return total + 0;
      }, 0);
      let campaignDiscounts = this.paymentGroups.reduce(function (total, num) {
        let totalEntries = num.entries.reduce(function (
          entriesTotal,
          entryDiscount
        ) {
          return (
            entriesTotal +
            Math.round(
              ((entryDiscount.originPrice || entryDiscount.price) - entryDiscount.price) * 1000
            ) /
            1000
          );
        },
          0);
        return total + totalEntries;
      }, 0);

      return paymentDiscounts + campaignDiscounts;
    },

    isActiveDiscount: {
      get() {
        return this.$refs.discount.isActive;
      },
      set(val) {
        this.$refs.discount.isActive = val;
      },
    },
    selectedPaymentMethod: {
      get() {
        return this.$store.getters["selfservice/getSelectedPaymentMethod"];
      },
      set(val) {
        if (val)
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
      },
    },
    paymentMethods: function () {
      return this.$store.getters["selfservice/getPaymentMethods"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    totalOriginPrice: function () {
      return this.calculateTotalOriginPrice(this.paymentGroups);
    },
    totalPrice: function () {
      return this.calculateSelectedRemainingPrice(this.paymentGroups);
    },
    selectedGroupsPrice: function () {
      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
    },
    currentCart: {
      get() {
        let cart = this.$store.getters["selfservice/getCurrentCart"];

        // FIX [v22]: Polling sırasında cart.active kaybolursa UUID bazlı geri yükle (Fallback)
        if (!cart && this.localBranchTableUId) {
           const allCarts = this.$store.getters["selfservice/getCarts"];
           cart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
        }

        return cart;
      },
      set(payload) {
        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);
      },
    },
    activePersonel:
    // function () {
    //  return this.$store.getters["selfservice/getActivePersonal"];
    //},
    {
      get() {
        let personal = this.$store.getters["selfservice/getActivePersonal"];
        console.log("activePersonel getter:", personal);

        // Eğer activePersonal null ise ve switch gizliyse, current user'ı kullan
        if (!personal && this.notSwitchQuery) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          console.log("userInfo from localStorage:", userInfo);

          if (userInfo) {
            this.$store.dispatch("selfservice/setActivePersonal", userInfo);
            return userInfo;
          }
        }
        return personal;
      },
      set(val) {
        this.$store.dispatch("selfservice/setActivePersonal", val);
      },
    },
    toggleCalc: {
      get() {
        return this.$refs.calculatorPage.isActive;
      },
      set(val) {
        this.$refs.calculatorPage.isActive = val;
      },
    },
  },

  methods: {
    getPaymentMethodIdFromPosResponse(resultData, defaultId) {
      let posStatusId = defaultId;
      if (resultData && resultData.addedPayments && Array.isArray(resultData.addedPayments)) {
        let successfulPayments = resultData.addedPayments.filter(p => p.statusId === 2);
        if (successfulPayments.length > 0) {
          let addedPayment = successfulPayments[successfulPayments.length - 1];
          let paymentTypeId = addedPayment.paymentTypeId;
          let mediatorId = addedPayment.paymentMediatorId;
          
          if (paymentTypeId) {
            posStatusId = paymentTypeId;
          }
          
          if (addedPayment.isExternal) {
            let targetMethodName = "";
            
            // Standard PAVO Mediator ID / PaymentType ID mappings for External Payments:
            // 1/101 = Multinet
            // 2/102 = Sodexo
            // 3/103/13/26/113/126 = Ticket (Edenred / Ticket Gift)
            // 4/104 = Setcard
            // 5/105 = Metropol
            // 6/106 = TokenFlex
            if (mediatorId === 1 || mediatorId === 101 || paymentTypeId === 1 || paymentTypeId === 101) {
              targetMethodName = "Multinet";
            } else if (mediatorId === 2 || mediatorId === 102 || paymentTypeId === 2 || paymentTypeId === 102) {
              targetMethodName = "Sodexo";
            } else if (
              mediatorId === 3 || mediatorId === 103 || mediatorId === 13 || mediatorId === 26 || mediatorId === 113 || mediatorId === 126 ||
              paymentTypeId === 3 || paymentTypeId === 103 || paymentTypeId === 13 || paymentTypeId === 26 || paymentTypeId === 113 || paymentTypeId === 126
            ) {
              targetMethodName = "Ticket";
            } else if (mediatorId === 4 || mediatorId === 104 || paymentTypeId === 4 || paymentTypeId === 104) {
              targetMethodName = "Setcard";
            } else if (mediatorId === 5 || mediatorId === 105 || paymentTypeId === 5 || paymentTypeId === 105) {
              targetMethodName = "Metropol";
            } else if (mediatorId === 6 || mediatorId === 106 || paymentTypeId === 6 || paymentTypeId === 106) {
              targetMethodName = "TokenFlex";
            }
            
            if (targetMethodName) {
              let matchingMethod = this.paymentMethods.find(m => 
                (m.Name && m.Name.toLowerCase().includes(targetMethodName.toLowerCase())) ||
                (m.name && m.name.toLowerCase().includes(targetMethodName.toLowerCase()))
              );
              if (matchingMethod) {
                posStatusId = matchingMethod.id;
              }
            }
          }
        }
      }
      return posStatusId;
    },
    mergeSelectedProducts() {
      if (this.selectedPaymentGroup.length <= 1) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Birleştirilecek en az 2 ürün seçmelisiniz.",
        });
        return;
      }

      // Seçilen grupları sakla ve ödenen tutarı hesapla
      this.selectedGroupsForMerge = [...this.selectedPaymentGroup];
      this.totalPayedPriceForMerge = 0;
      this.selectedGroupsForMerge.forEach((group) => {
        this.totalPayedPriceForMerge += group.payedPrice || 0;
      });

      // Modal aç ve input temizle
      this.newMergePrice = "";
      this.isMergeModalOpen = true;

      // Input'a focus ver
      this.$nextTick(() => {
        if (this.$refs.txtMergePrice) {
          this.$refs.txtMergePrice.focus();
        }
      });
    },
    async loadKitchens() {
      try {
        const res = await getAllKitchen();
        this.kitchens = res.data || [];
      } catch (err) {
        console.error("OrderList: Kitchens load failed:", err);
      }
    },
    appendToPrice(value) {
      // Eğer nokta ekleniyor ve zaten nokta varsa, ekleme
      if (value === '.' && this.newMergePrice.includes('.')) {
        return;
      }

      // Nokta sonrası en fazla 2 basamak
      if (this.newMergePrice.includes('.')) {
        const decimalPart = this.newMergePrice.split('.')[1];
        if (decimalPart && decimalPart.length >= 2 && value !== '.') {
          return;
        }
      }

      this.newMergePrice += value;
    },
    clearPrice() {
      if (this.newMergePrice.length > 0) {
        this.newMergePrice = this.newMergePrice.slice(0, -1);
      }
    },
    confirmMergeFromModal() {
      const newPrice = parseFloat(this.newMergePrice);

      if (!newPrice || newPrice <= 0) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: "Geçerli bir fiyat giriniz.",
        });
        return;
      }

      if (newPrice < this.totalPayedPriceForMerge) {
        this.$vs.notify({
          color: "warning",
          title: "Uyarı",
          text: `Yeni fiyat en az ${this.$toCurrency(this.totalPayedPriceForMerge)} olmalıdır (ödenen tutar).`,
        });
        return;
      }

      // Modal kapat
      this.isMergeModalOpen = false;
      this.newMergePrice = "";

      // Birleştirme işlemini yap
      this.confirmMerge(newPrice);
    },
    cancelMerge() {
      this.isMergeModalOpen = false;
      this.newMergePrice = "";
      this.selectedGroupsForMerge = [];
      this.totalPayedPriceForMerge = 0;
    },
    confirmMerge(newPrice) {
      // Seçilen grupların verilerini hesapla
      let totalOriginalPrice = 0;
      let totalPayedPrice = 0;
      this.selectedGroupsForMerge.forEach((group) => {
        totalOriginalPrice += group.totalPrice || 0;
        totalPayedPrice += group.payedPrice || 0;
      });

      // Fiyat farkını hesapla
      const priceDifference = totalOriginalPrice - newPrice;

      // Yeni birleştirilmiş grup oluştur
      let mergedGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: newPrice,
        payedPrice: totalPayedPrice,
        status: "Kalan",
      };

      // Tüm entry'leri birleştir
      this.selectedGroupsForMerge.forEach((group) => {
        mergedGroup.entries = mergedGroup.entries.concat(group.entries);
      });

      // Entry fiyatlarını ayarla (ilk entry'ye tüm fiyat, diğerleri 0)
      if (mergedGroup.entries.length > 0) {
        mergedGroup.entries[0].price = newPrice;
        for (let i = 1; i < mergedGroup.entries.length; i++) {
          mergedGroup.entries[i].price = 0;
        }
      }

      // Seçilen grupları kaldır ve yeni grubu ekle
      let remainingGroups = this.paymentGroups.filter((group) =>
        !this.selectedGroupsForMerge.some((selected) => selected.rowIndex === group.rowIndex)
      );
      remainingGroups.push(mergedGroup);
      this.paymentGroups = remainingGroups;

      // Eğer fiyat indirimi varsa, Kampanya ödeme yöntemi olarak ekle
      if (priceDifference > 0) {
        let campaignPayment = {
          id: uuid.v1(),
          paymentMethod: {
            id: 15, // Kampanya payment method ID'si
            name: "Kampanya"
          },
          price: priceDifference,
          value: priceDifference,
          unit: "₺",
          description: "Ürün Birleştirme İndirimi",
          discountDescription: `${this.$toCurrency(totalOriginalPrice)} → ${this.$toCurrency(newPrice)}`,
        };
        this.orderPayments.push(campaignPayment);
      }

      // Seçimi temizle
      this.selectedPaymentGroup = [];
      this.selectedGroupsForMerge = [];
      this.totalPayedPriceForMerge = 0;

      // Fiyatları yeniden hesapla
      this.reCalculatePaymentGroup();

      this.$vs.notify({
        color: "success",
        title: "Başarılı",
        text: `Seçilen ürünler ${this.$toCurrency(newPrice)} fiyatı ile birleştirildi.`,
      });
    },
    commitQrCode(customer) {
      this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
    },
    getTotalGift(row) {
      let totalGift = row.entries.reduce(function (total, num) {
        if (num.originPrice - num.price > 0)
          return total + (num.originPrice - num.price);
        else return total + 0;
      }, 0);
      return this.$toCurrency(totalGift);
    },
    initValues() {
      this.selectedGift = null;
      let cart = this.$store.getters["selfservice/getCurrentCart"];
      
      // FIX: Early Recovery for initValues
      if (cart) {
          this.localBranchTableUId = cart.branchTableUId;
          this.localBranchId = cart.branchId || (this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);
          this.tableId = cart.tableId;
      }
      
      // FIX: Early Recovery for initValues
      if (!cart && this.localBranchTableUId) {
         console.warn("initValues (OrderList Recovery): currentCart is NULL, recovery by UUID:", this.localBranchTableUId);
         const allCarts = this.$store.getters["selfservice/getCarts"];
         cart = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
      }

      if (!cart) {
          console.error("initValues (OrderList): CRITICAL - Sepet verisine ulaşılamadı!");
          return;
      }

      this.orderPayments = cart.orderPayments ? _.cloneDeep(cart.orderPayments) : [];

      this.paymentGroups =
        cart.paymentGroups != null
          // eslint-disable-next-line no-undef
          ? _.cloneDeep(cart.paymentGroups)
          : [];
      this.selectedPaymentGroup = [];
      // eslint-disable-next-line no-undef
      this.cloneCurrentCart = _.cloneDeep(cart);
      this.generatePaymentGroups();
      this.isTransaction = false;
      this.isPrintOrders = true;
    },
    generatePaymentGroups() {
      // this.paymentGroups.length = 0;
      const cart = this.$store.getters["selfservice/getCurrentCart"];
      if (!cart) return;
      const allEntries = [...(cart.cartEntries || [])];
      const carts = this.$store.getters["selfservice/getCarts"];
      
      if (cart.mergedIds && Array.isArray(cart.mergedIds)) {
        cart.mergedIds.forEach(mid => {
          const mCart = carts.find(c => c && c.id === mid);
          if (mCart && mCart.cartEntries) {
            allEntries.push(...mCart.cartEntries);
          }
        });
      }

      allEntries.forEach((entry) => {
        if (!this.paymentGroups.some((group) => group.rowIndex === entry.id)) {
          let tempPaymentGroup = {
            rowIndex: entry.id,
            entries: [_.cloneDeep(entry)],
            totalPrice: entry.price,
            payedPrice: 0,
            status: "Kalan",
          };
          this.paymentGroups.push(tempPaymentGroup);
        }
      });
      this.reCalculatePaymentGroup();
    },
    initGifts() {
      if (this.currentCart.customer) {
        let cart = this.currentCart;
        cart.cartEntries.forEach((x) => {
          x.categoryId = x.categories[0].id;
        });
        let payments = this.orderPayments;
        let orderModel = {
          id: cart.id,
          customerId: cart.customer ? cart.customer.id : null,
          qrCode: cart.customer ? cart.customer.giftQrCode : null,
          totalPrice: cart.totalPrice,
          active: cart.active,
          cartEntries: [...cart.cartEntries],
          branchName: this.$currentUser ? this.$currentUser.branch.name : (this.$store.state.AppActiveUser.branch.name),
          paymentInformations: [...payments],
          userName: this.activePersonel ? this.activePersonel.name : "",
          userId: this.activePersonel ? this.activePersonel.id : null,
        };
        FindAvailableCampaigns(orderModel)
          .then((res) => {
            if (res && res.status == 200) {
              if (res.data.isValid) {
                let clonedCart = Object.assign({}, this.currentCart);
                clonedCart.cartEntries = res.data.newEntries;
                if (res.data.customerGiftId != null)
                  clonedCart.customerGiftId = res.data.customerGiftId;
                else if (res.data.campaignGiftId != null)
                  clonedCart.campaignGiftId = res.data.campaignGiftId;
                this.$store.dispatch('selfservice/updateCartsById', [clonedCart]);
                this.generatePaymentGroups();
              }
            } else {
              this.$fire({
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: "Hata : " + res.status,
                text: "Kampanyalara Erişilemedi !",
              });
            }
          })
          .catch(() => {
            this.$fire({
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          });
      }
    },
    async appendDiscount(discountObj) {
      if (this.isTransaction) return;
      this.isTransaction = true;
      try {
        // Eğer kalem seçili değilse tüm kalemleri baz al
        let targetGroups = (this.selectedPaymentGroup && this.selectedPaymentGroup.length > 0) 
          ? this.selectedPaymentGroup 
          : this.paymentGroups;

        // Tüm girişlerin ID'lerini topla (kalem bazlı indirim için)
        let logIds = [];
        targetGroups.forEach(group => {
          if (group.entries && group.entries.length > 0) {
            group.entries.forEach(entry => {
              logIds.push(entry.id);
            });
          }
        });

        this.paymentDiscount = {
          paymentMethod: this.selectedPaymentMethod,
          value: discountObj.value,
          description: discountObj.description,
          unit: discountObj.unit,
          selectedPaymentGroup: logIds,
          payedPrice: discountObj.payedPrice,
          discountDescription: discountObj.discountDescription,
        };

        if (this.isPosEnabled) {
          await this.doPay(discountObj.priceToDiscount, true);
        } else {
          await this.doPayWithoutPos(discountObj.priceToDiscount, true);
        }

        // İndirim log kaydı için backend API'sini çağır (UUID bazlı koruma)
        try {
          const currentTableUUID = (this.currentCart && this.currentCart.branchTableUId) ? this.currentCart.branchTableUId : this.localBranchTableUId;
          const currentBranchId = this.localBranchId || (this.$store.state.AppActiveUser.branch ? this.$store.state.AppActiveUser.branch.id : null);

          await addDiscountLog({
            branchTableUId: currentTableUUID,
            branchId: currentBranchId,
            ids: logIds,
            totalDiscount: discountObj.payedPrice,
            discountType: "Discount",
            actionType: "Discount",
            description: discountObj.description || "İndirim Uygulandı"
          });
        } catch (logError) {
          console.error("Discount log error (OrderList.js):", logError);
        }
        this.discounts.push(this.paymentDiscount);
        this.paymentDiscount = {};
      } finally {
        this.isTransaction = false;
      }
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      extra.variants.forEach((x) => {
          returnObj.push("x" + x.quantity + " / " + x.name);
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    createCommitModel: async function () {
      if (this.isTransaction == true) {
        return;
      }

      // 0. SEPET KURTARMA (RECOVERY) - Polling sırasında null gelirse store'dan UUID bazlı geri al
      let cartSnapshot = this.currentCart ? JSON.parse(JSON.stringify(this.currentCart)) : null;
      if (!cartSnapshot && this.localBranchTableUId) {
          console.warn("createCommitModel (OrderList.js Recovery): currentCart is NULL, attempting recovery by UUID:", this.localBranchTableUId);
          const allCarts = this.$store.getters["selfservice/getCarts"];
          const recovered = allCarts.find(c => c && c.branchTableUId == this.localBranchTableUId);
          if (recovered) {
              cartSnapshot = JSON.parse(JSON.stringify(recovered));
              cartSnapshot.active = true; 
              console.log("createCommitModel (OrderList.js): Cart recovered successfully by UUID.");
          }
      }

      if (!cartSnapshot) {
          console.error("createCommitModel (OrderList.js): CRITICAL - Sepet verisine ulaşılamadı!");
          this.$vs.notify({ color: "danger", title: "Hata", text: "Sepet verisine ulaşılamadı. Lütfen tekrar deneyiniz." });
          return;
      }

      this.isTransaction = true;

      // [v26 ARMOR] - ATOMIC SYNC: CompletePayment öncesi sunucudan en güncel state'i al
      if (this.isTableMode && cartSnapshot && cartSnapshot.id) {
          try {
              const latestCartRes = await getOrderEntries(cartSnapshot.id);
               if (latestCartRes && latestCartRes.data) {
                    if (latestCartRes.data.rowVersion) {
                        cartSnapshot.rowVersion = latestCartRes.data.rowVersion;
                        console.log("[v29-OrderList] RowVersion updated from Cart API:", cartSnapshot.rowVersion);
                    } else {
                        console.warn("[v29-OrderList] Cart API returned NULL rowVersion, attempting Master Sync...");
                        try {
                                  // [v37-OMEGA-RESERVE] Force wake-up call to the server
                                  console.log("[v37-OMEGA-RESERVE] OrderList Forcing server-side table reservation for:", cartSnapshot.tableId);
                                  try {
                                      await reserveTable(cartSnapshot.tableId);
                                      const freshCartsRes = await getCarts();
                                      if (freshCartsRes && freshCartsRes.data) {
                                          this.$store.dispatch("selfservice/setToCart", freshCartsRes.data);
                                          const serverCart = freshCartsRes.data.find(c => c && c.tableId == cartSnapshot.tableId);
                                           if (serverCart) {
                                              cartSnapshot.rowVersion = serverCart.rowVersion;
                                              cartSnapshot.id = serverCart.id;
                                              cartSnapshot.realId = serverCart.id;
                                              // [v39-OMEGA-UUID] Server UUID is the absolute Law
                                              if (serverCart.branchTableUId) {
                                                  cartSnapshot.branchTableUId = serverCart.branchTableUId;
                                              }
                                              console.log("[v39-OMEGA-UUID-OrderList] Synchronized - RowVersion:", cartSnapshot.rowVersion, "RealId:", cartSnapshot.id, "UUID:", cartSnapshot.branchTableUId);
                                          }
                                      }
                                  } catch (resErr) { console.error("[v37-OMEGA-RESERVE-OrderList] Reserve/Pull Failed:", resErr); }

                                  const masterTableRes = await getCartsByTableId(cartSnapshot.id || cartSnapshot.tableId);
                            if (masterTableRes && masterTableRes.data && masterTableRes.data.rowVersion) {
                                cartSnapshot.rowVersion = masterTableRes.data.rowVersion;
                                console.log("[v29-OrderList-MASTER] RowVersion recovered from BranchTables:", cartSnapshot.rowVersion);
                                if (!cartSnapshot.branchTableUId && masterTableRes.data.branchTableUId) {
                                  cartSnapshot.branchTableUId = masterTableRes.data.branchTableUId;
                                }
                            }
                        } catch (masterErr) {
                            console.error("[v29-OrderList-MASTER] Master Sync Failed:", masterErr);
                        }
                    }

                   // CRITICAL: UUID Missing in Snapshot? Fix it from local or store or GENERATE [v26 ARMOR-HEAL]
                  if (!cartSnapshot.branchTableUId) {
                      cartSnapshot.branchTableUId = latestCartRes.data.branchTableUId || this.localBranchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null);
                      
                      if (!cartSnapshot.branchTableUId) {
                          cartSnapshot.branchTableUId = uuid.v1();
                          console.warn("[ARMOR v26-HEAL-OrderList] UUID STILL NULL. Generated new one:", cartSnapshot.branchTableUId);
                      }
                  }
                  console.log("[ARMOR v26-OrderList] Atomic Sync Final Data:", { 
                      rowVersion: cartSnapshot.rowVersion, 
                      branchTableUId: cartSnapshot.branchTableUId 
                  });
              }
          } catch(e) { console.error("[ARMOR v26-OrderList] Atomic Sync Failed:", e); }
      }

      let cart = cartSnapshot;
      let payments = this.orderPayments;

      // DOĞRULAVA: Sepet boşsa uyarı ver ama bakiye 0 ise devama izin ver
      if (!cart.cartEntries || cart.cartEntries.length === 0) {
        console.warn("OrderList.js createCommitModel: Sepet boş görünüyor, bakiye kontrolü yapılıyor.");
        if (Math.round(this.totalPrice * 100) > 0) {
           this.$vs.notify({
             color: "danger",
             title: "İşlem Tamamlanamadı",
             text: "Sepetiniz boş görünüyor. Lütfen ürünleri kontrol edip tekrar deneyiniz.",
             position: "top-center"
           });
           this.isTransaction = false;
           return;
        }
      }

      // [v31-FORCE-SAVE] Eğer hala RowVersion yoksa (Hayalet Sepet), sunucuya zorla kaydet
      if (this.isTableMode && !cart.rowVersion) {
          console.warn("[v33-FORCE-SAVE-OrderList] RowVersion still missing. Forcing server record creation...");
          try {
              const forceSaveRes = await setBranchCart({ 
                  value: cart, 
                  tableId: cart.id || cart.tableId, 
                  branchTableUId: cart.branchTableUId 
              });
              if (forceSaveRes && forceSaveRes.data) {
                  const sData = forceSaveRes.data;
                  // [v40-DEEP-FORCE] Capture EVERYTHING from the server response
                  cart.rowVersion = sData.rowVersion || sData.RowVersion;
                  if (sData.id || sData.Id) {
                      const newId = sData.id || sData.Id;
                      cart.id = newId;
                      cart.realId = newId;
                      cart.tableId = newId; // [v40] Anchor tableId to the record ID
                      console.log("[v40-DEEP-FORCE-OrderList] ID Anchored to Server Record ID:", cart.id);
                  }
                  if (sData.branchTableUId || sData.BranchTableUId) {
                      cart.branchTableUId = sData.branchTableUId || sData.BranchTableUId;
                  }
                  console.log("[v40-DEEP-FORCE-OrderList] Sync Success. RowVersion:", cart.rowVersion, "UUID:", cart.branchTableUId);
              }
          } catch (forceErr) {
              console.error("[v33-FORCE-SAVE-OrderList] Force Save Failed:", forceErr);
          }
      }

      // [v36-DEEP-SYNC] Masa Numarası -> Gerçek Sunucu ID'si Eşleşmesi
      let serverSideTableId = cart.tableId; 
      try {
          const allCarts = this.$store.getters["selfservice/getCarts"] || [];
          const serverCart = allCarts.find(c => c && (c.tableId == cart.tableId));
          if (serverCart && serverCart.id && serverCart.id > 1000) {
              serverSideTableId = serverCart.id;
              console.log(`[v36-DEEP-SYNC] OrderList.js Mapped Table ${cart.tableId} to ServerID: ${serverSideTableId}`);
          }
      } catch (deepErr) { console.error("[v36-DEEP-SYNC] Lookup Failed:", deepErr); }

      // v107: Termal Yazıcı İçin Veri Zenginleştirme (Snapshot'a enjekte et)
      if (cart) {
          cart.totalOriginPrice = parseFloat(this.totalOriginPrice) || 0;
          cart.totalDiscountPrice = parseFloat(this.totalDiscountPrice) || 0;
          cart.totalPayedPrice = parseFloat(cart.totalPrice) || 0;
          cart.isAdisyon = false; // Ödeme fişi olduğu için false
          
          if (cart.cartEntries) {
              cart.cartEntries.forEach(entry => {
                  if (!entry.originPrice) entry.originPrice = entry.price;
              });
          }
      }

      let orderModel = {
        id: cart.id || 0,
        tableId: cart.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
        branchTableUId: cart.branchTableUId || (this.$store.getters['selfservice/getCurrentCart'] ? this.$store.getters['selfservice/getCurrentCart'].branchTableUId : null),
        rowVersion: cart.rowVersion || null,
        isNavigatedByQuestion: cart.isNavigatedByQuestion,
        customerId: cart.customer ? cart.customer.id : null,
        totalPrice: cart.totalPrice,
        userName: this.activePersonel ? `${this.activePersonel.name} ${this.activePersonel.surname}` : null,
        userId: this.activePersonel ? this.activePersonel.id : null,
        discounts: [...(this.discounts || [])],
        cart: JSON.parse(JSON.stringify(cart)),
        paymentInformations: [...this.orderPayments],
        cartEntries: this.orderBillEntries,
        submissionId: this.submissionId || ("sub_" + Date.now()),
        branchId: this.$store.state.AppActiveUser.branch.id,
        orderStatus: 1,
        orderDeliveryType: 1
      };
      let isFullTable = false;
      try {
        let result;
      try {
          result = await completePayment(orderModel);
          console.log("[v34-DEBUG-OrderList] completePayment Result:", result);
      } catch (err) {
          console.error("[v34-DEBUG-ERROR-OrderList] 422 Body:", err.response ? err.response.data : "No response data");
          this.$vs.notify({ color: "danger", title: "Hata", text: "Ödeme backend tarafından onaylanmadı." });
          this.isTransaction = false;
          return;
      }

        /*
        if (this.isTableMode) {
          // Self-service senaryosunda dialogu bypass et veya daha hızlı geçiş sağla
          if (this.currentCart && this.currentCart.notSeat) {
             isFullTable = false; 
          } else {
            await new Promise((resolve) => {
              this.$vs.dialog({
                type: "confirm",
                color: "warning",
                title: "Müşteri Durumu",
                text: "Müşteri masadan kalktı mı?",
                acceptText: "Evet, Kalktı",
                cancelText: "Hayır, Hala Oturuyor",
                accept: () => {
                  isFullTable = false;
                  resolve();
                },
                cancel: () => {
                  isFullTable = true;
                  resolve();
                },
              });
            });
          }
        }
        */
        isFullTable = false; // Default to 'customer left' to clear table (PASSED per user request)

        this.discounts = [];
        if (result && result === true) {
          this.orderBillNo = cart.orderNo;
          
          if (this.isPrintOrders && this.$refs.printer) {
            this.$refs.printer.printOrders(null, true);
            // YARDIMCI GECİKME: PrintJS'nin DOM'u okuması için süre tanı
            await new Promise((resolve) => setTimeout(resolve, 500));
          }

          let totalEntryPrice = this.orderPayments.reduce(
            (a, b) => a + (b.price || 0),
            0
          );
          this.orderPayments = [];
          this.isReset = true;
          this.isActive = false;
          this.isCakeQuestioned = false;
          this.$store.dispatch("selfservice/setLastBillId");
          //TODO AFTER PRINT
          this.$vs.notify({
            color: "success",
            title: totalEntryPrice.toFixed(2) + " Tutarında Sepet Tamamlandı !",
            text: payments.length + " Ödeme Gerçekleşti.",
          });
          // MASA KAPATMA (Cleanup) - Sadece sipariş başarıyla geçince yap
          let lastCurrentCart = this.$store.getters["selfservice/getCurrentCart"];
          let payloadCart = Object.assign({}, lastCurrentCart);
          payloadCart.paymentGroups = [];
          payloadCart.cartEntries = [];
          payloadCart.totalPrice = 0;
          payloadCart.totalPayedPrice = 0;
          payloadCart.orderPayments = [];
          
          if (payloadCart.notSeat) {
            this.$store.dispatch("selfservice/removeCart", payloadCart.id);
          } else {
            if (this.isTableMode) {
              payloadCart.isFullTable = isFullTable;
              this.$store.dispatch("selfservice/updateCartsById", [payloadCart]);
              await setBranchCart({
                value: payloadCart,
                tableId: payloadCart.tableId,
                branchTableUId: payloadCart.branchTableUId, 
                remove: payloadCart.notSeat,
              });
            } else {
              this.$store.dispatch("selfservice/updateCartsById", [payloadCart]);
            }
          }
          this.discounts = [];
          this.isPieced = false;
          this.$emit("switchToTableMap");
        } else {
          // Response but not success
          console.error("[ARMOR v27] Payment NOT accepted by server.");
          this.$fire({ title: "Hata !", text: "Ürün Satışı Tamamlanamadı !", type: "error" });
          this.isTransaction = false;
        }
      } catch (err) {
        // Network Error or Exception
        console.error("[ARMOR v27] createCommitModel Critical Error:", err);
        this.$fire({ title: "Hata !", text: "Sipariş kaydedilemedi (422/Lokal): " + (err.message || ""), type: "error" });
        this.isTransaction = false;
      }
    },
    seperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.paymentGroups
        );
        this.toggleCalc = true;
      }
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let branchId = userInfo.branch.id;
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posType = axiosResponse.data.posType;
    },
    setIsPieced: function () {
      this.isPieced = true;
    },
    doPayWithoutPos: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return; 
      this.isTransaction = true;
      try {
        if (
          this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID
        ) {
          this.openQrReader(payedPrice, isDiscount);
          return;
        }
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }

        // Oransal Dağıtım Mantığı (Merge yerini alıyor)
        var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
        var distributedAmount = 0;
        var payedPriceFloat = parseFloat(payedPrice);

        this.selectedPaymentGroup.forEach((group, index) => {
          var remaining = group.totalPrice - group.payedPrice;
          var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
          
          var chunk = 0;
          if (index === this.selectedPaymentGroup.length - 1) {
            // Son kalem kuruş farklarını alır
            chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
          } else {
            chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
          }
          
          group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
          if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
          
          distributedAmount += chunk;

          // Eğer tamamen ödendiyse durumunu güncelle
          if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
            group.status = "Ödendi";
          }
        });

        var selectedPgs = this.selectedPaymentGroup.map(pg => pg.rowIndex);
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.selectedPaymentGroup = [];
        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
          discountDescription: isDiscount
            ? this.paymentDiscount.discountDescription
            : null,
          selectedPaymentGroup: this.selectedPaymentGroup.map(pg => pg.rowIndex),
        };
        this.orderPayments.push(orderPayment);

        this.toggleCalc = false;

        // SAFE CLONE & RECOVERY: Reaktivite veya polling sırasında sepetin kaybolması durumuna karşı UUID koruması
        let cart = Object.assign({}, this.$store.getters["selfservice/getCurrentCart"] || {});
        if (!cart.id && (this.localBranchTableUId || this.tableId)) {
            const recoveryUUID = this.localBranchTableUId;
            const recoveryTableId = this.tableId;
            console.warn("doPayWithoutPos (OrderList.js): currentCart is NULL, attempting recovery.");
            
            const allCarts = this.$store.getters["selfservice/getCarts"];
            const recovered = allCarts.find(c => 
                (recoveryUUID && c && c.branchTableUId == recoveryUUID) || 
                (!recoveryUUID && recoveryTableId && c && c.tableId == recoveryTableId)
            );

            if (recovered) {
                cart = Object.assign({}, recovered);
                cart.active = true; // Re-activate it locally
                console.log("doPayWithoutPos (OrderList.js): Cart recovered successfully by UUID/TableId.");
            }
        }

        cart.paymentGroups = JSON.parse(JSON.stringify(this.paymentGroups));
        cart.totalPayedPrice =
          Math.round(((cart.totalPayedPrice || 0) + payedPrice) * 100) / 100;
        cart.orderPayments = JSON.parse(JSON.stringify(this.orderPayments));
        
        // Store'u güncelle ki bir sonraki adım taze veri görsün
        this.$store.dispatch('selfservice/updateCartsById', [cart]);
        
        const saveRes = await setBranchCart({ 
          value: cart, 
          tableId: cart.tableId,
          branchTableUId: cart.branchTableUId // UUID bazlı koruma
        });

        if (saveRes && saveRes.data && saveRes.data.rowVersion) {
          cart.rowVersion = saveRes.data.rowVersion;
          this.$store.dispatch('selfservice/updateCartsById', [cart]);
        }

        this.$nextTick(() => {
          this.calculateSelectedRemainingPrice(this.paymentGroups);
        });
      } finally {
        this.isTransaction = false;
      }
    },
    doPay: async function (payedPrice, isDiscount) {
      if (this.isTransaction && !isDiscount) return;
      this.isTransaction = true;
      try {
        if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) {
          this.doPayGmp(payedPrice, isDiscount);
          return;
        }
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }
        let removeIndex = [];
        let tempGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: parseFloat(payedPrice),
          status: "Kalan",
        };
        let vm = this;
        this.paymentGroups.forEach((item) => {
          tempGroup.rowIndex = uuid.v1();
          if (vm.selectedPaymentGroup.some((s) => s.rowIndex == item.rowIndex)) {
            tempGroup.entries = tempGroup.entries.concat(item.entries);
            // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
            removeIndex.push(item.rowIndex);
          }
        });
        let posSaleItems = [];
        this.selectedPaymentGroup.forEach(function (selectProduct) {
          if (selectProduct.payedPrice != selectProduct.totalPrice) {
            let priceToPay = selectProduct.totalPrice - selectProduct.payedPrice;
            
            if (selectProduct.entries.length == 1) {
              let saleModel = {
                name: selectProduct.entries[0].productName,
                quantity: selectProduct.entries[0].quantity,
                kdv: selectProduct.entries[0].kdv,
                price: priceToPay,
              };
              posSaleItems.push(saleModel);
            } else {
              let groupRemaining = selectProduct.totalPrice - selectProduct.payedPrice;
              let groupDistributed = 0;

              selectProduct.entries.forEach((entry, eIdx) => {
                let entryRemaining = entry.price;
                let eRatio = groupRemaining > 0 ? (entryRemaining / selectProduct.totalPrice) : 0;
                let eChunk = 0;
                
                if (eIdx === selectProduct.entries.length - 1) {
                  eChunk = Math.round((priceToPay - groupDistributed) * 100) / 100;
                } else {
                  eChunk = Math.round((priceToPay * eRatio) * 100) / 100;
                }

                let saleModel = {
                  name: entry.productName,
                  quantity: entry.quantity,
                  kdv: entry.kdv,
                  price: eChunk,
                };
                posSaleItems.push(saleModel);
                groupDistributed += eChunk;
              });
            }
          }
        });
        this.isLoading = true;
        if (isDiscount) {
          this.isLoading = false;
          if (this.selectedPaymentGroup.length == 0) {
            this.selectedPaymentGroup = this.paymentGroups;
          }

          // Oransal Dağıtım Mantığı (Merge yerini alıyor)
          var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
          var distributedAmount = 0;
          var payedPriceFloat = parseFloat(payedPrice);

          this.selectedPaymentGroup.forEach((group, index) => {
            var remaining = group.totalPrice - group.payedPrice;
            var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
            
            var chunk = 0;
            if (index === this.selectedPaymentGroup.length - 1) {
              // Son kalem kuruş farklarını alır
              chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
            } else {
              chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
            }
            
            group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
            if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
            
            distributedAmount += chunk;

            // Eğer tamamen ödendiyse durumunu güncelle
            if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
              group.status = "Ödendi";
            }
          });

          this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
            this.selectedPaymentGroup
          );
          this.selectedPaymentGroup = [];

          this.reCalculatePaymentGroup();

          let orderPayment = {
            id: uuid.v1(),
            paymentMethod: this.selectedPaymentMethod,
            price: payedPrice,
            value: isDiscount ? this.paymentDiscount.value : null,
            unit: isDiscount ? this.paymentDiscount.unit : null,
            description: isDiscount ? this.paymentDiscount.description : null,
          };
          this.orderPayments.push(orderPayment);
          // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
          this.toggleCalc = false;
        } else {
          if (
            this.selectedPaymentMethod.id !=
            process.env.VUE_APP_CASH_PAYMENT_ID &&
            this.selectedPaymentMethod.id != process.env.VUE_APP_CREDIT_PAYMENT_ID
          ) {
            await this.doPayWithoutPos(payedPrice, isDiscount);
            this.isLoading = false;
            return;
          }
          // var token = localStorage.getItem("auth-token");
          await fetch(process.env.VUE_APP_POS_API + "complete-sale", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              PaymentType:
                this.selectedPaymentMethod.id ==
                  process.env.VUE_APP_CREDIT_PAYMENT_ID
                  ? 4
                  : 1,
              SaleItems: posSaleItems,
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              this.isLoading = false;
              if (data.hasError == true) {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata",
                  text: data.message,
                });
                this.$fire({
                  title: "İptal",
                  text: data.message,
                  type: "error",
                });
                return;
              }
              if (data.data.statusId == 4) {
                let posStatusId = this.getPaymentMethodIdFromPosResponse(data.data, this.selectedPaymentMethod.id);
                if (this.selectedPaymentGroup.length == 0) {
                  this.selectedPaymentGroup = this.paymentGroups;
                }
                let removeIndex = [];
                let tempGroup = {
                  rowIndex: uuid.v1(),
                  entries: [],
                  totalPrice: 0,
                  payedPrice: parseFloat(payedPrice),
                  status: "Kalan",
                };
                let vm = this;

                this.paymentGroups.forEach((item) => {
                  tempGroup.rowIndex = uuid.v1();
                  if (
                    vm.selectedPaymentGroup.some(
                      (s) => s.rowIndex == item.rowIndex
                    )
                  ) {
                    tempGroup.entries = tempGroup.entries.concat(item.entries);
                    tempGroup.payedPrice =
                      Math.round(
                        (tempGroup.payedPrice + item.payedPrice) * 1000
                      ) / 1000;
                    removeIndex.push(item.rowIndex);
                  }
                });

                let removedPaymentGroup = [];

                this.paymentGroups.forEach((x, index) => {
                  if (!removeIndex.some((rm) => rm == x.rowIndex)) {
                    removedPaymentGroup.push(vm.paymentGroups[index]);
                  }
                });
                removedPaymentGroup.push(tempGroup);

                this.paymentGroups = removedPaymentGroup;

                this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
                  this.selectedPaymentGroup
                );
                this.selectedPaymentGroup = [];

                this.reCalculatePaymentGroup();

                let orderPayment = {
                  id: uuid.v1(),
                  // eslint-disable-next-line no-undef
                  paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
                  price: payedPrice,
                  value: isDiscount ? this.paymentDiscount.value : null,
                  unit: isDiscount ? this.paymentDiscount.unit : null,
                  description: isDiscount
                    ? this.paymentDiscount.description
                    : null,
                };
                orderPayment.paymentMethod.id = posStatusId;
                if (
                  data.data.financialDocuments &&
                  data.data.financialDocuments.length > 0
                ) {
                  orderPayment.financialDocument =
                    data.data.financialDocuments[0];
                  orderPayment.financialDocument.saleUid = data.data.saleUid;
                  orderPayment.financialDocument.orderNo = data.data.orderNo;
                }

                // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
                this.orderPayments.push(orderPayment);
                this.toggleCalc = false;

                this.$nextTick(() => {
                  this.calculateSelectedRemainingPrice(this.paymentGroups);
                });
              } else {
                this.$fire({
                  title: "İptal",
                  text: "Ödeme iptal edildi",
                  type: "error",
                });
                this.$vs.notify({
                  color: "danger",
                  title: data.message,
                  text: "",
                });
              }
            })
            .catch(() => {
              this.isLoading = false;
              this.$fire({
                title: "Hata !",
                text: "İstek başarısız oldu. Tekrar Deneyiniz.",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: "İstek başarısız oldu. Tekrar Deneyiniz.",
                text: "",
              });
            });
        }
      } finally {
        this.isTransaction = false;
      }
    },
    reCalculatePaymentGroup: function () {
      this.paymentGroups.forEach((pgroup) => {
        let totalPrice = 0;

        pgroup.entries.forEach((entry) => {
          totalPrice += Math.round(entry.price * 100) / 100;
        });
        pgroup.totalPrice = Math.round(totalPrice * 100) / 100;
      });
    },
    doPayGmp: function (payedPrice, isDiscount) {
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan",
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some((s) => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });
      let posSaleItems = [];
      this.selectedPaymentGroup.forEach(function (selectProduct) {
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          let priceToPay = selectProduct.totalPrice - selectProduct.payedPrice;
          
          if (selectProduct.entries.length == 1) {
            let saleModel = {
              name: selectProduct.entries[0].productName,
              quantity: selectProduct.entries[0].quantity,
              kdv: selectProduct.entries[0].kdv,
              price: priceToPay,
            };
            posSaleItems.push(saleModel);
          } else {
            let groupRemaining = selectProduct.totalPrice - selectProduct.payedPrice;
            let groupDistributed = 0;

            selectProduct.entries.forEach((entry, eIdx) => {
              let entryRemaining = entry.price;
              let eRatio = groupRemaining > 0 ? (entryRemaining / selectProduct.totalPrice) : 0;
              let eChunk = 0;
              
              if (eIdx === selectProduct.entries.length - 1) {
                eChunk = Math.round((priceToPay - groupDistributed) * 100) / 100;
              } else {
                eChunk = Math.round((priceToPay * eRatio) * 100) / 100;
              }

              let saleModel = {
                name: entry.productName,
                quantity: entry.quantity,
                kdv: entry.kdv,
                price: eChunk,
              };
              posSaleItems.push(saleModel);
              groupDistributed += eChunk;
            });
          }
        }
      });
      this.isLoading = true;
      if (isDiscount) {
        this.isLoading = false;
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }

        // Oransal Dağıtım Mantığı (Merge yerini alıyor)
        var totalRemaining = this.selectedPaymentGroup.reduce((sum, g) => sum + (g.totalPrice - g.payedPrice), 0);
        var distributedAmount = 0;
        var payedPriceFloat = parseFloat(payedPrice);

        this.selectedPaymentGroup.forEach((group, index) => {
          var remaining = group.totalPrice - group.payedPrice;
          var pRatio = totalRemaining > 0 ? (remaining / totalRemaining) : 0;
          
          var chunk = 0;
          if (index === this.selectedPaymentGroup.length - 1) {
            // Son kalem kuruş farklarını alır
            chunk = Math.round((payedPriceFloat - distributedAmount) * 100) / 100;
          } else {
            chunk = Math.round((payedPriceFloat * pRatio) * 100) / 100;
          }
          
          group.payedPrice = Math.round((group.payedPrice + chunk) * 100) / 100;
          if (group.payedPrice > group.totalPrice) group.payedPrice = group.totalPrice;
          
          distributedAmount += chunk;

          // Eğer tamamen ödendiyse durumunu güncelle
          if (Math.round(group.totalPrice * 100) <= Math.round(group.payedPrice * 100)) {
            group.status = "Ödendi";
          }
        });

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
          this.selectedPaymentGroup
        );
        this.selectedPaymentGroup = [];

        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
      } else {
        // var token = localStorage.getItem("auth-token");
        fetch(process.env.VUE_APP_POS_API + "create", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            PaymentType:
              this.selectedPaymentMethod.id ==
                process.env.VUE_APP_CREDIT_PAYMENT_ID
                ? 4
                : 1,
            SaleItems: posSaleItems,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            this.isLoading = false;
            if (data.statusCode == 200) {
              if (this.selectedPaymentGroup.length == 0) {
                this.selectedPaymentGroup = this.paymentGroups;
              }
              let removeIndex = [];
              let tempGroup = {
                rowIndex: uuid.v1(),
                entries: [],
                totalPrice: 0,
                payedPrice: parseFloat(payedPrice),
                status: "Kalan",
              };
              let vm = this;

              this.paymentGroups.forEach((item) => {
                tempGroup.rowIndex = uuid.v1();
                if (
                  vm.selectedPaymentGroup.some(
                    (s) => s.rowIndex == item.rowIndex
                  )
                ) {
                  tempGroup.entries = tempGroup.entries.concat(item.entries);
                  tempGroup.payedPrice =
                    Math.round(
                      (tempGroup.payedPrice + item.payedPrice) * 1000
                    ) / 1000;
                  removeIndex.push(item.rowIndex);
                }
              });

              let removedPaymentGroup = [];

              this.paymentGroups.forEach((x, index) => {
                if (!removeIndex.some((rm) => rm == x.rowIndex)) {
                  removedPaymentGroup.push(vm.paymentGroups[index]);
                }
              });
              removedPaymentGroup.push(tempGroup);

              this.paymentGroups = removedPaymentGroup;

              this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
                this.selectedPaymentGroup
              );
              this.selectedPaymentGroup = [];

              this.reCalculatePaymentGroup();

              let orderPayment = {
                id: uuid.v1(),
                paymentMethod: this.selectedPaymentMethod,
                price: payedPrice,
                value: isDiscount ? this.paymentDiscount.value : null,
                unit: isDiscount ? this.paymentDiscount.unit : null,
                description: isDiscount
                  ? this.paymentDiscount.description
                  : null,
              };
              // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
              this.orderPayments.push(orderPayment);
              this.toggleCalc = false;
            } else {
              this.$fire({
                title: data.message,
                text: "",
                type: "error",
              });
              this.$vs.notify({
                color: "danger",
                title: data.message,
                text: "",
                position: "center",
              });
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.$fire({
              title: "Hata !",
              text: "İstek başarısız oldu. Tekrar Deneyiniz.",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "İstek başarısız oldu. Tekrar Deneyiniz.",
              text: "",
            });
          });
      }
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        item.entries.forEach((entry) => {
          selectedPrice += (entry.originPrice || entry.price || 0);
        });
      });
      return Math.round(selectedPrice * 100) / 100;
    },

    commitPay(payedPrice, isDiscount) {
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan",
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some((s) => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice =
            Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some((rm) => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(
        this.selectedPaymentGroup
      );
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();
      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
      };
      this.orderPayments.push(orderPayment);
      this.toggleCalc = false;
      this.$vs.notify({
        color: "success",
        title: "Tebrikler",
        text: payedPrice + " TL Değerinde Ödeme Gerçekleşti.",
      });
    },
    openQrReader(amount, isDiscount) {
      this.$refs.qrReader.isActive = true;
      this.$refs.qrReader.isWallet = true;
      this.$refs.qrReader.amount = amount.toFixed(2);
      this.$refs.qrReader.isDiscount = isDiscount;
    },
    calculateSelectedRemainingPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach((item) => {
        selectedPrice += item.totalPrice - item.payedPrice;
      });
      return Math.round(selectedPrice * 100) / 100;
    },
    closeCalculatorPage() {
      this.isCalculatorPageActive = false;
    },
  },
  created() {
    this.checkPosDevice();
  },
};